<template>
<div class="contact">
  <div class="overlay"><h1>Contact</h1></div>
<div class="overlay">
  <div class="social">
<a href="https://www.behance.net/nicolas-noel"><i class="fab fa-behance"></i></a><a href="https://www.instagram.com/la_discorde/"><i class="fab fa-instagram"></i></a><a href="https://fr-fr.facebook.com/LaDiscordeArt/"><i class="fab fa-facebook-f"></i></a>
  </div>
</div>
  <div class="overlay">
  <form>
    <div v-if="successSend" class="successSend">Message bien envoyé !</div>
    <div class="errorForm">

      <ul v-if="errors.length">
        <li v-for="error in errors">
          {{error}}
        </li>
      </ul>
    </div>

    <div class="row sm-block">
<div class="col-3 sm-hide">

</div>
<div class="col-3 col-sm-12">
  <label for="fname">Prénom</label>
  <input type="text" id="fname" name="firstname" placeholder="Nom" v-model="form.fname">

</div>
<div class="col-3 col-sm-12">
  <label for="lname">Nom</label>
  <input type="text" id="lname" name="lastname" placeholder="Prénom" v-model="form.lname">

</div>
<div class="col-3 col-sm-12">
  <label for="email">Email</label>
  <input type="email" id="email" name="email" placeholder="Email" v-model="form.email">

</div>



    </div>

<div class="row sm-block">
  <div class="col-3">

  </div>
  <div class="col-6 col-sm-12">
    <label for="subject">Objet</label>
    <textarea id="subject" name="subject" placeholder="Objet" style="height:200px" v-model="form.subject"></textarea>

  </div>
  <div class="col-3 col-sm-12">
    <vue-recaptcha  ref="recaptcha"  size="invisible" @verify="register" @expired="onCaptchaExpired" sitekey="6LfrHK8UAAAAAP2XHXexAYo45Z0bHWj6VPIsvPKx"></vue-recaptcha>

    <input id="submitForm" type="submit" value="Envoyer" @click.prevent="validate">
    <div><small>This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </small></div>

  </div>

</div>








</form>
</div>
</div>
</template>

<script>

import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'

// url:'https://www.nicolas-noel.net/api/index.php/wp-json/send-contact-form/v1/contact',

export default {
  components: {
     VueRecaptcha
  },
  data:function(){
    return {
      publicPath: process.env.BASE_URL,
      successSend:false,
      url:'https://www.nicolas-noel.net/api/index.php/wp-json/contact-form-7/v1/contact-forms/45/feedback',
      contact:{},
      form:{
        fname:'',
        lname:'',
        email:'',
        subject:'',
      },
      errors: []
    }
  },
  mounted(){

  },
  methods:{
    submitForm(){


    },

    register () {
      // make post request to the server
      this.$refs.recaptcha.reset()
      axios.post(this.url, this.form)
      .then((response) => {
        if(response.data=='success'){
          this.successSend = true;
        }
        this.errors = [];
      })
      .catch((error)=>{
        this.successSend = false;
        this.errors = error.response.data.message;
      });
    },

    validate () {
      // if validate true exec recaptcha
      this.$refs.recaptcha.execute()
    },

    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>


<style scoped>
.contact{
  background-image: url('../assets/backhalf.png');
  background-size: contain;
  background-repeat: no-repeat;
    background-position:  left -50%;
    background-color: #222;
    padding: 15rem 7.5rem 0 7.5rem;
  color: #dec8b2;
  line-height: 1.5rem;
}

h1 {
  text-align: right;
  color: #fff;
  font-size: 8rem;
    font-weight: bold;
    margin-bottom: 6.25rem;
    line-height: 6rem;
}

.social{

    text-align: right;
    width: 100%;
    font-size: 1.5rem;

}

.social i{
  margin-left: 2rem;
    color: #dec8b2;
    transition: 0.3s
}

.social i:hover{
    color: #fff;
        transition: 0.3s
}

label{
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  text-transform: uppercase;
  color: #888;
        line-height: 2.25rem;
        display: block;
        width: 100%;

}

input{
  background-color: #222;
  border: solid 1px #dec8b2;
  color: #dec8b2;
  padding: 0.5rem;
      font-family: 'Cormorant', serif;
      margin-bottom: 2.5rem;
      width: 100%;
}

textarea{
  background-color: #222;
  border: solid 1px #dec8b2;
  color: #dec8b2;
  padding: 0.5rem;
      font-family: 'Cormorant', serif;
      margin-bottom: 2.5rem;
      width: 100%;
}

#submitForm{
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  text-transform: uppercase;
  color: #222;
        line-height: 2.25rem;
    background-color: #dec8b2;
    width:100%;
    margin-top: 2.25rem;
          margin-bottom: 2.5rem;
          cursor: pointer;
          transition: 0.3s;
          border: solid 1px #dec8b2;
  }

  #submitForm:hover{
        background-color: #222;
          color: #dec8b2;
          border: solid 1px #dec8b2;
          transition: 0.3s;
  }

.successSend{
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  text-transform: uppercase;
  text-align: right;
}

.col-6, .col-3{
  padding-left: 1.25rem;
}

.errorForm{
  text-align: right;
}



@media all and (max-width: 736px) {

  .sm-block{
    display: block;
  }

 .contact{
       padding: 15rem 4rem 4rem 4rem;
       font-size: 2rem;
       line-height: 3rem;
 }

 .social{
   font-size: 3rem;
 }
}

</style>
